export const SLA_CATEGORIES = [
  { value: 'within_sla', label: 'Within SLA' },
  { value: 'completed_outside_sla', label: 'Completed outside SLA' },
  { value: 'aborted_outside_sla', label: 'Aborted outside SLA' },
] as const

export type SlaCategory = (typeof SLA_CATEGORIES)[number]['value']

export const SLA_CATEGORY_VALUES: readonly SlaCategory[] = SLA_CATEGORIES.map(
  (category) => category.value
)

export const formatSlaCategory = (slaCategory: SlaCategory) => {
  const match = SLA_CATEGORIES.find((category) => category.value === slaCategory)
  return match?.label ?? slaCategory
}

const slaCategoryColours: Record<SlaCategory, string> = {
  within_sla: '#168039',
  completed_outside_sla: '#e04613',
  aborted_outside_sla: '#d8232a',
}

export const slaCategoryColour = (slaCategory: SlaCategory) =>
  slaCategoryColours[slaCategory]
